import { CodeFieldIncludeInactiveValues } from 'app/area/indicator-factors/types-store';

export const codeFieldIncludeInactive: CodeFieldIncludeInactiveValues = {
  active: {
    enabled: false
  },
  all: {
    enabled: true
  }
};
